<div class="subscribe-nav">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="logo">
      <img src="assets/classjax-logo-dark.svg" alt="ClassJax" />
    </div>
    <div class="welcome-text">Welcome to ClassJax</div>
  </div>
</div>

<div class="subscribe-header">
  @if (isTrialEligible) {
    <h1>Start Your 14-Day Free Trial</h1>
    <p class="subtitle">
      Try ClassJax free for 14 days. Cancel anytime.
    </p>
  } @else {
    <h1>Choose Your Plan</h1>
    <p class="subtitle">
      Select a plan to continue using ClassJax.
    </p>
  }
</div>

<app-plans></app-plans>

<div class="subscribe-footer">
  <a [href]="pricingUrl" target="_blank" class="pricing-link">View full plan details</a>
  <span class="divider">·</span>
  <button class="btn btn-link" (click)="navigateBack()">
    {{ isSubscribed ? "Back to planner" : "Back to signin" }}
  </button>
</div>
